export function getStorageData(type) {
  let filtersTotal = [];
  let storageGroup = localStorage.getItem("managerinternal_filter_group") || [];
  if (storageGroup.length !== 0) {
    storageGroup = storageGroup.split(",").map(Number);

    filtersTotal = filtersTotal.concat(storageGroup);
  }
  let storageState = localStorage.getItem("managerinternal_filter_state") || [];
  if (storageState.length !== 0) {
    storageState = storageState.split(",");

    if (storageState.includes("AT")) {
      const changeArray = storageState.filter(
        (val) => val !== "ATOS" && val !== "CHND" && val !== "RV"
      );
      filtersTotal = filtersTotal.concat(changeArray);
    } else {
      filtersTotal = filtersTotal.concat(storageState);
    }
  }

  if (type === "storageState") return storageState;
  if (type === "storageGroup") return storageGroup;
  if (type === "filtersTotal") return filtersTotal;

  return [];
}
